import { CardTitleContentExtension } from "@tiptap-content/extensions/card-title/card-title-content-extension"
import { ReactNodeViewRenderer } from "@tiptap/react"
import { cancelBackspaceAtNodeStart } from "../../util/cancel-backspace-at-node-start"
import { mergeEmptyCardIntoCardAbove } from "../../util/merge-empty-card-into-card-above"
import { CardTitleComponent } from "./card-title-component"

export const ExtensionCardTitle = CardTitleContentExtension.extend({
  addKeyboardShortcuts() {
    return {
      Backspace: () =>
        mergeEmptyCardIntoCardAbove(this.editor) ||
        cancelBackspaceAtNodeStart(this.editor, this.name),
      "Shift-Backspace": () => cancelBackspaceAtNodeStart(this.editor, this.name),
      "Mod-Backspace": () => cancelBackspaceAtNodeStart(this.editor, this.name),
      "Alt-Backspace": () => cancelBackspaceAtNodeStart(this.editor, this.name),
    }
  },

  addNodeView() {
    return ReactNodeViewRenderer(CardTitleComponent, { contentDOMElementTag: "span" })
  },
})
